import { httpCreate } from './http';
import conf from '@/config';

const http = httpCreate(conf.apipath + '/watchConfig');

export const watchConfig = {
	unBoundSurvey(activityId) {
		return http.post(`/survey/unBound//${activityId}`);
	},
};
